import { useState } from 'react';
import { useAuth } from '../lib/auth';
import { CupIcon } from '../components/CupIcon';
import { APP_VERSION } from '../lib/version';

export function Login() {
  const { signInPassword, signInMagicLink } = useAuth();
  const [mode, setMode] = useState<'senha' | 'link'>('senha');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setOk(null);
    setBusy(true);
    if (mode === 'senha') {
      const { error } = await signInPassword(email.trim(), password);
      if (error) setErr(traduz(error));
    } else {
      const { error } = await signInMagicLink(email.trim());
      if (error) setErr(traduz(error));
      else setOk('Enviamos um link de acesso para o seu e-mail.');
    }
    setBusy(false);
  }

  return (
    <div className="login-wrap">
      <form className="card card-pad login-card" onSubmit={submit}>
        <div className="login-logos">
          <img
            className="login-logo"
            src="/logo-trevo.png"
            alt="Trevo Lácteos"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = 'none';
            }}
          />
          <img
            className="login-logo"
            src="/logo-ehrmann.png"
            alt="Ehrmann"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>
        <div className="mark" style={{ margin: '0 auto 8px' }}>
          <CupIcon size={22} />
        </div>
        <h1>Workflow de Novos Produtos</h1>
        <p className="sub">Acesso restrito aos membros da organização</p>

        <div className="chip-toggle" style={{ marginBottom: 16, justifyContent: 'center' }}>
          <button type="button" className={mode === 'senha' ? 'on' : ''} onClick={() => setMode('senha')}>
            Senha
          </button>
          <button type="button" className={mode === 'link' ? 'on' : ''} onClick={() => setMode('link')}>
            Link por e-mail
          </button>
        </div>

        <div className="field">
          <label>E-mail</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@empresa.com"
            autoComplete="email"
          />
        </div>

        {mode === 'senha' && (
          <div className="field">
            <label>Senha</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
        )}

        <button className="btn-primary" style={{ width: '100%', marginTop: 6 }} disabled={busy}>
          {busy ? 'Aguarde…' : mode === 'senha' ? 'Entrar' : 'Enviar link'}
        </button>

        {mode === 'senha' && (
          <p className="muted" style={{ fontSize: 12, marginTop: 12, textAlign: 'center' }}>
            <b>Primeiro acesso?</b> Use a senha provisória fornecida pelo administrador
            (<b>npd1234</b>). No próximo passo você define a sua senha pessoal.
          </p>
        )}

        {err && <p className="err">{err}</p>}
        {ok && <p className="ok">{ok}</p>}
        <p className="muted" style={{ fontSize: 10.5, marginTop: 14, textAlign: 'center' }}>
          {APP_VERSION}
        </p>
      </form>
    </div>
  );
}

function traduz(msg: string): string {
  if (/invalid login credentials/i.test(msg)) return 'E-mail ou senha inválidos.';
  if (/email not confirmed/i.test(msg)) return 'E-mail ainda não confirmado.';
  if (/failed to fetch|networkerror|load failed|network request failed/i.test(msg))
    return 'Sem conexão com o servidor. Verifique a internet e a rede — pode ser bloqueio da rede corporativa (firewall/proxy) ou de uma extensão do navegador. Tente pelo 4G do celular ou em uma aba anônima.';
  return msg;
}
